module.exports = __webpack_public_path__ + "static/img/dlogo.3e6f48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo.png
// module id = LwjX
// module chunks = 12